import useVuelidate from '@vuelidate/core';
import { cloneDeep } from 'lodash';
import { mapActions, mapState } from 'vuex';

import { SNACKBAR_TYPES } from '@/utils/constants';
import {
  email as emailValidator,
  mobile as phoneValidator,
  phone as extValidator,
  required,
} from '@/utils/validators';

export default {
  name: 'UserInfos',
  setup() {
    return { userValidator$: useVuelidate({ $lazy: true }) };
  },
  data() {
    return {
      originForm: {},
      form: {},
      showSaveButton: false,
      showUserQrCode: false,
    };
  },
  computed: {
    ...mapState('user', {
      departments: ({ departments }) => departments,
      gettingDepartments: ({ gettingDepartments }) => gettingDepartments,
      gettingUser: ({ gettingUser }) => gettingUser,
      user: ({ user }) => user,
      saving: ({ updatingUser }) => updatingUser,
    }),
    hasUserInfo() {
      return !!Object.keys(this.user)?.length;
    },
    loading() {
      return this.gettingDepartments || this.gettingUser;
    },
    unitText() {
      const { name } = this.departments?.find(({ id }) => id === this.user?.unit) || {};
      return name || '無所屬部門';
    },
  },
  async created() {
    await this.getDepartments();
    await this.getUser();
    const {
      email,
      enablePickupCode,
      ext,
      name,
      phone,
    } = this.user;

    const form = {
      email,
      enablePickupCode,
      ext,
      name,
      phone,
    };
    this.form = cloneDeep(form);
    this.originForm = cloneDeep(form);
  },
  beforeDestroy() {
    Object.assign(this.$data, this.$options.data.apply(this));
  },
  watch: {
    showUserQrCode(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        const { pickup_code: code } = this.user || {};
        this.$nextTick(() => {
          this.$qrCode.toCanvas(
            document.getElementById('qrCode'),
            code,
            { margin: 2, width: 152 },
          );
        });
      }
    },
    'userValidator$.form.$model': {
      deep: true,
      handler(newVal) {
        const stringifyNewVal = JSON.stringify(newVal);
        const stringifyOrigin = JSON.stringify(this.originForm);

        this.showSaveButton = stringifyNewVal !== stringifyOrigin;
      },
    },
  },
  methods: {
    ...mapActions('user', {
      getDepartments: 'GET_DEPARTMENTS',
      getUser: 'GET_USER',
      updateUser: 'UPDATE_USER',
    }),
    async save() {
      const valid = await this.userValidator$.form.$validate();
      if (!valid) return;

      try {
        await this.updateUser(this.form);
        this.originForm = { ...this.originForm, ...this.form };
        this.showSaveButton = false;
        this.$snackbar({ type: SNACKBAR_TYPES.SUCCESS, title: '個人資訊更新成功！' });
      } catch (error) {
        const { message: msg } = error;
        this.$snackbar({ type: SNACKBAR_TYPES.ERROR, msg });
      }
    },
    getErrorMsgs(field) {
      return this.userValidator$.form?.[field]?.$errors?.[0]?.$message;
    },
    hasErrorMsgs(field) {
      return !!this.userValidator$.form?.[field]?.$errors?.length;
    },
    toggleUserQrCode() {
      this.showUserQrCode = !this.showUserQrCode;
    },
  },
  validations() {
    return {
      form: {
        email: { emailValidator },
        ext: { extValidator },
        name: { required: required('姓名') },
        phone: { phoneValidator },
      },
    };
  },
};
